import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Field, reduxForm, getFormValues } from 'redux-form';
import { _t } from "../util/Translator";
import Pagination from "../components/Pagination";
import * as AfeFields from "../components/AfeFields";
import * as Actions from "../actions";
import store from "../store";

class JobsScreen extends Component {
  state = {
    activePage: 1
  };

  componentDidMount() {
    console.log("job params:", this.props.searchJobsParams);
    store.dispatch(Actions.getPublishedJobs(this.props.searchJobsParams));
  }

  onClick = (job) => {
    console.log(job);
  }


  onSubmit = (formValues) => {
    this.setState({ activePage: 1 }, () => {
      this.refreshJobs(formValues);
    });
  }

  refreshJobs = (formValues) => {
    console.log('form values', formValues);

    var salaryRange = {};
    switch (formValues.salaryRange) {
      case "25-30": salaryRange = { min: 25000, max: 30000 }; break;
      case "30-40": salaryRange = { min: 30000, max: 40000 }; break;
      case "40-50": salaryRange = { min: 40000, max: 50000 }; break;
      case ">50": salaryRange = { min: 50000, max: null }; break;
      default: salaryRange = { min: null, max: null }; break;
    }
    const searchJobsParams = {
      keywords: formValues.keywords,
      localization: formValues.localization,
      minSalary: salaryRange.min,
      maxSalary: salaryRange.max,
      page: this.state.activePage - 1,
      size: 10
    };

    store.dispatch(Actions.updateSearchJobsParams(searchJobsParams));
    store.dispatch(Actions.getPublishedJobs(searchJobsParams));
  }

  getTitleText = (text) => {
    if (text == null) return "";
    // return text != null && text.length > 80 ? text.substring(0, 80).toUpperCase() : text.toUpperCase();
    return text != null && text.substring(0, 80);
  }

  getCompactText = (text) => {
    return text != null && text.length > 190 ? text.substring(0, 190) + "..." : text;
  }

  getSalaryText = (salarioMinimo, salarioMaximo) => {
    if (salarioMinimo != null && salarioMaximo != null)
      return salarioMinimo + " - " + salarioMaximo;
    if (salarioMinimo == null && salarioMaximo == null)
      return "Competitivo";
    if (salarioMinimo != null)
      return "Desde " + salarioMinimo + " €";
    if (salarioMaximo != null)
      return "Hasta " + salarioMaximo + " €";
  }

  onPageChange = (page) => {
    this.setState({ activePage: page }, () => {
      this.refreshJobs(this.props.formValues);
    });
  }

  render() {
    const { handleSubmit, submitting, error } = this.props;

    return (
      <Fragment>
        <div className="container-fluid pt-5 zero-text-hanken zero-container">
          <div className="row border-bottom pl-0 pb-4 mb-5">
            <div className="section-marker">
              <div className="section-marker-title ml-lg-0 pl-lg-0 zero-text-medium zero-text-color-primary zero-text-40">{_t("jobs.sectionTitle")}</div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-12 col-lg-4 pl-lg-0 mb-5">
              <div>

                <div className="card zero-shadow-card">
                  <div className="card-body md-p-10">
                    {error && <div className="alert alert-danger" role="alert">
                      <ul>{error && error.map(item => {
                        return <li key={item.field}>{item.field}: {item.message}</li>
                      })}</ul></div>}
                    <form onSubmit={handleSubmit(this.onSubmit)}>
                      <h5 className="card-title zero-text-color-primary zero-text-semi zero-text-25 ">{_t("jobs.keywords")}</h5>
                      <div className="row">
                        <div className="col-md-12 mb-2">
                          <Field name="keywords" type="text" component={AfeFields.Input} placeholder={_t("jobs.keywords")} />
                        </div>
                      </div>
                      <h5 className="card-title zero-text-color-primary zero-text-semi zero-text-25">{_t("jobs.localizacion")}</h5>
                      <div className="row">
                        <div className="col-md-12 mb-2">
                          <Field name="localization" type="text" component={AfeFields.Input} value="" placeholder={_t("jobs.localizacion")} />
                        </div>
                      </div>
                      <h5 className="card-title zero-text-color-primary zero-text-semi zero-text-25">{_t("jobs.salario")}</h5>
                      <div className="row">
                        <div className="col-md-12 ml-4 mb-4 zero-radio-option">
                          <Field name="salaryRange" type="radio" component={AfeFields.Radio} value="" label={_t("jobs.cualquiera")} />
                          <Field name="salaryRange" type="radio" component={AfeFields.Radio} value="25-30" label="25.000 - 30.000 €" />
                          <Field name="salaryRange" type="radio" component={AfeFields.Radio} value="30-40" label="30.000 - 40.000 €" />
                          <Field name="salaryRange" type="radio" component={AfeFields.Radio} value="40-50" label="40.000 - 50.000 €" />
                          <Field name="salaryRange" type="radio" component={AfeFields.Radio} value=">50" label="> 50.000 €" />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <button type="submit" className="btn btn-primary font-default-normal w-100 zero-height-56" disabled={submitting}>{_t("jobs.buscar")}</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-8">
              {this.props.jobList && this.props.jobList.map(job => {
                return <div key={job.id} className="row mb-4">
                  <div className="col-md-12 pr-lg-0">

                    <div className="card zero-shadow-card">
                      <div className="card-body md-p-10">
                        <h6 className="card-title ">
                          <Link className="zero-text-25 zero-text-semi zero-text-color-primary" to={"/jobs/" + job.id}>
                            {this.getTitleText(job.publishedTitle)}
                          </Link>
                        </h6>
                        <p className="card-text zero-text-regular zero-text-18">
                          {this.getCompactText(job.publishedText)}
                        </p>
                        <div className="row pt-4 align-items-center">
                          <div className="col-sm-6 pb-2 pb-sm-0">
                            <div className="d-flex">
                              <p className="card-text zero-text-regular zero-text-18 mb-0 mr-4"><i className="fas fa-map-marker-alt zero-text-color-primary"></i> {job.provincia.name}</p>
                              <p className="card-text zero-text-regular zero-text-18 mb-0"><i className="fas fa-euro-sign zero-text-color-primary"></i> {this.getSalaryText(job.salarioMinimo, job.salarioMaximo)}</p>
                            </div>
                          </div>
                          <div className="col-sm-6 flex-fill text-right ">
                            <Link className="btn btn-primary float-lg-right font-default-normal zero-text-18 zero-btn" to={"/jobs/" + job.id}>{_t("jobs.detalle")}</Link>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>;
              })}

              <Pagination
                hideFirstLastPages
                pageRangeDisplayed={5}
                activePage={this.state.activePage}
                itemsCountPerPage={10}
                totalItemsCount={this.props.totalElements}
                onChange={this.onPageChange}
              />
            </div>
          </div>

        </div>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {}
  return errors;
}

const warn = values => {
  const warnings = {}
  return warnings;
}

const form = reduxForm({
  form: 'jobsScreen', // a unique identifier for this form
  validate, // <--- validation function given to redux-form
  warn,  // <--- warning function given to redux-form
  enableReinitialize: true,
  destroyOnUnmount: false
})(JobsScreen);

const mapStateToProps = (state, ownProps) => {
  console.log("the form values", getFormValues('jobsScreen')(state));

  return {
    initialValues: state.searchJobsParams,
    searchJobsParams: state.searchJobsParams,
    jobList: state.jobList.content != null ? state.jobList.content : [],
    totalElements: state.jobList.totalElements != null ? state.jobList.totalElements : 0,
    formValues: getFormValues('jobsScreen')(state)
  };
};

export default connect(mapStateToProps, {})(form);
